/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import SaveCrmLeadListBody from "components/CRMComponents/CRMLeadListComponents/SaveCrmLeadListBody/SaveCrmLeadListBody";

const SaveCrmLead = () => {
  useEffect(() => {
    document.title = "CRM Leads Create";
    window.scroll(0, 0);
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <SaveCrmLeadListBody />
    </main>
  );
};

export default SaveCrmLead;
